import React from 'react';

export default function FounderQuote() {
  return (
    <section className="relative w-full bg-[#f8d768] py-36 lg:py-56">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10 text-center">
        <img
          src="/spiick_imgs/founder-avatar.png"
          alt="Claudy S. — Spiick Founder"
          className="mx-auto mb-8 lg:mb-10 w-[110px] h-[110px] lg:w-[140px] lg:h-[140px] object-contain select-none pointer-events-none"
        />
        <p
          className="text-[25px] sm:text-[31px] lg:text-[40px] leading-[1.18] tracking-tight"
          style={{ fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, letterSpacing: '-0.025em', color: '#4409cc' }}
        >
          Spiick uses just the right amount of AI, so children&rsquo;s intelligence and English skills never become artificial.
        </p>
        <p
          className="mt-8 lg:mt-10 text-[14px] lg:text-[15px] tracking-wide"
          style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 500, color: '#4409cc', opacity: 0.75 }}
        >
          Claudy S. &mdash; Spiick Founder
        </p>
      </div>
    </section>
  );
}
